/**
 * The name a project's integration goes by on screen (LED-763).
 *
 * Every integration-specific word on the console comes from here, keyed off
 * the project's own `syncSource`, so an Autodesk customer never reads
 * "Procore" (and the reverse). `null` is a real answer — a project with no
 * link — and callers print neutral copy for it rather than guessing.
 */

export type SyncSource = "procore" | "autodesk";

export function integrationName(source: SyncSource | null | undefined): "Procore" | "Autodesk" | null {
  if (source === "procore") return "Procore";
  if (source === "autodesk") return "Autodesk";
  return null;
}

/** The one integration every row shares, or `undefined` when they differ or none is linked. */
export function sharedSyncSource(rows: ReadonlyArray<{ syncSource?: SyncSource }>): SyncSource | undefined {
  const sources = new Set(rows.map((row) => row.syncSource));
  return sources.size === 1 ? [...sources][0] : undefined;
}
